<div class="wrapper" style="width:100%">
  <header class="header">
    <lib-header [app]="'gasflow'"></lib-header>
  </header>
  <lib-loader></lib-loader>
  <lib-unit-settings-dialogue></lib-unit-settings-dialogue>
  <section class="content">
    <div *ngIf="!loggedIn" style="width:50%;min-width:400px;margin-left:auto;margin-right:auto;">
      <login (loginStateChange)="setLoggedIn($event)"></login>
    </div>
    <app-calculation *ngIf="loggedIn" style="width:90%; margin-left: auto;margin-right:auto;"></app-calculation>
  </section>
  <footer class="footer">
    <lib-footer></lib-footer>
  </footer>
</div>

<dx-popup *ngIf="preview" class="popup" [width]="400" [height]="400" [showTitle]="true" title="Demonstrator Version" [closeOnOutsideClick]="true" [visible]="true" style="padding:0px">
  <div *dxTemplate="let data of 'content'" style="padding:0px">
      <b> WARNING </b>
      <p>This is a demonstrator version of Pumpcalc Gasflow that should only be used for testing.</p>
      <p>If you are not testing please use our <a href="https://simtools.edwardsvacuum.com/gasflow">latest release</a></p>
  </div>
</dx-popup>
